import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import upload from "../../assets/Vehicles/upload_img.png";

export const DocUploader = ({
  label = "Upload file",
  description = "Drag & drop or choose a file",
  onFileSelect,
}) => {
  const fileInputRef = useRef(null);
  const [filePreview, setFilePreview] = useState(null);
  const [dragging, setDragging] = useState(false);

  const handleInputFile = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      /* setFilePreview(fileUrl); */
      if (onFileSelect) onFileSelect(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
    /*   setFilePreview(fileUrl); */
      if (onFileSelect) onFileSelect(file);
    }
  };

  const handleDelete = () => {
    setFilePreview(null);
    fileInputRef.current.value = "";
    if (onFileSelect) onFileSelect(null);
  };

  return (
    <div
      className={`bg-white p-3 my-2 rounded-4 ${
        dragging ? "border border-primary bg-light" : ""
      }`}
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
      onDragEnter={() => setDragging(true)}
      onDragLeave={() => setDragging(false)}
    >
      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          {filePreview ? (
            <img
              src={filePreview}
              alt="Uploaded Preview"
              className="rounded"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "cover",
              }}
            />
          ) : (
            <img
              src={upload}
              alt="Upload Icon"
              style={{ width: "60px", height: "60px" }}
            />
          )}

          <div className="d-flex flex-column">
            <p className="fw-semibold m-0">{label}</p>
            <p className="m-0 fs-14 text-muted-grey">{description}</p>
          </div>
        </div>

        {filePreview ? (
          <Button
            className="bg-danger border-0 text-white rounded-pill px-4 py-2 fw-500"
            onClick={handleDelete}
          >
            Delete
          </Button>
        ) : (
          <Button
            className="bg-transparent choose-file-border-grey text-dark-purple rounded-pill px-4 py-2 fw-500"
            onClick={handleInputFile}
          >
            Choose from files
          </Button>
        )}

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          className="d-none"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};
